import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X, CircleAlert } from 'lucide-react';
import { Button } from '../ds';
import { cx } from '../ds/classes';
import { useAuth } from '../../context/AuthContext';

// Hiding it lasts the visit, so it doesn't come back on every page of the site or the studio
const HIDDEN_KEY = 'tpf-verify-banner-hidden';

const wasHidden = () => {
  try {
    return sessionStorage.getItem(HIDDEN_KEY) === '1';
  } catch {
    return false;
  }
};

/**
 * Shown under the site nav and the studio bar to signed-in accounts that haven't verified their
 * email yet. `centered` keeps it in the site's column; the studio runs it edge to edge.
 */
export const VerifyBanner = ({ centered = false }) => {
  const { user, isLoggedIn } = useAuth();
  const [hidden, setHidden] = useState(wasHidden);

  if (!isLoggedIn || !user || user.is_verified || hidden) return null;

  const hide = () => {
    setHidden(true);
    try {
      sessionStorage.setItem(HIDDEN_KEY, '1');
    } catch {
      // Storage can be blocked; it then stays hidden until the bar remounts
    }
  };

  return (
    <div className="bg-surface font-text">
      <div className={cx(centered && 'max-w-[1200px] mx-auto', 'px-space-4 sm:px-space-6 py-space-1 flex flex-wrap items-center gap-x-space-3')}>
        <CircleAlert size={18} strokeWidth={2.5} aria-hidden="true" className="flex-none text-coral" />
        <span className="flex-1 min-w-[200px] py-space-2 text-small text-ink">Verify your email to start analyzing your clips.</span>
        <Button as={Link} to="/verify-pending" variant="text">Verify now</Button>
        <Button variant="icon" icon={X} aria-label="Hide this notice" onClick={hide} />
      </div>
    </div>
  );
};
